module.exports = __webpack_public_path__ + "static/media/document-icon-3.da913e7b.png";